import React from 'react';
import '../../App.css';
import ProjectList from '../ProjectList';


function Projects() {
    return(
        <>
            <ProjectList />
            <footer>
                &copy; Copyright All Rights Reserved 2021, Nicholas Sidharta
            </footer>
        </>
    );
}

export default Projects;
